<template>
    <ul class="pl-chips">
        <slot />
    </ul>
</template>

<script setup>
</script>

<style scoped>
.pl-chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--pl-gap-sm);
    margin: 0;
    padding: 0;
    list-style: none;
}
</style>
